import { useState, useEffect } from "react";
import { useApp } from "../context/AppContext";

// Пряме підключення (push, як MetaGo) — альтернатива SDK. Обидві схеми працюють паралельно.
export default function DirectConnectView() {
  const { proj, activeId, apiFetch, dark, t, card, inp, btnP, btnG, flash } = useApp();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cms, setCms] = useState("custom");
  const [keyVal, setKeyVal] = useState("");
  const [keyBusy, setKeyBusy] = useState(false);

  useEffect(() => {
    if (!activeId) return;
    setLoading(true);
    apiFetch(`/api/projects/${activeId}/legacy-metago/status`)
      .then(r => r.json()).then(d => setStatus(d)).catch(() => setStatus(null))
      .finally(() => setLoading(false));
  }, [activeId, apiFetch]);

  const domain = (proj?.domain || "domain.com").replace(/^https?:\/\//, "").replace(/\/$/, "");
  const pluginPath = status?.path || "/spalah-push/";

  const saveKey = async (gen) => {
    setKeyBusy(true);
    try {
      const r = await apiFetch(`/api/projects/${activeId}/legacy-metago/key`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ key: gen ? "" : keyVal.trim(), generate: gen }) });
      const d = await r.json();
      if (d.error) { flash("Помилка: " + d.error); }
      else { setKeyVal(d.key || ""); flash("Ключ збережено"); apiFetch(`/api/projects/${activeId}/legacy-metago/status`).then(x => x.json()).then(setStatus).catch(() => {}); }
    } catch (e) { flash("Помилка: " + e.message); }
    setKeyBusy(false);
  };
  const copy = (txt) => { try { navigator.clipboard.writeText(txt); flash("Скопійовано"); } catch { /* no-op */ } };
  const Code = ({ children }) => (
    <div style={{ position: "relative", marginTop: 8 }}>
      <pre style={{ margin: 0, padding: "12px 14px", background: dark ? "#14141f" : "#f6f7fb", border: `1px solid ${t.border}`, borderRadius: 10, fontSize: 12, lineHeight: 1.5, overflow: "auto", color: t.text, whiteSpace: "pre" }}>{children}</pre>
      <button onClick={() => copy(children)} style={{ ...btnG, position: "absolute", top: 8, right: 8, fontSize: 10, padding: "3px 8px" }}>Копіювати</button>
    </div>
  );
  const Step = ({ n, title, children }) => (
    <div style={{ ...card, padding: 18, marginBottom: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
        <span style={{ width: 26, height: 26, borderRadius: 8, background: "rgba(99,102,241,0.15)", color: "#6366f1", fontWeight: 700, fontSize: 13, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{n}</span>
        <div style={{ fontSize: 15, fontWeight: 700 }}>{title}</div>
      </div>
      <div style={{ fontSize: 13, color: t.text, lineHeight: 1.6 }}>{children}</div>
    </div>
  );

  const hookSnippets = {
    custom: `require_once __DIR__.'/spalah-push/spalah_client.php';\nob_start('spalah_client_html_replace'); // на самому початку index.php`,
    wp: `// wp-content/mu-plugins/spalah-push.php\nrequire_once ABSPATH.'spalah-push/spalah_client.php';\nadd_action('template_redirect', function () {\n  ob_start('spalah_client_html_replace');\n}, 0);`,
    opencart: `// system/library/response.php -> output()\n$output = spalah_client_html_replace($output);`,
  };

  return (
    <div style={{ maxWidth: 920, margin: "0 auto", padding: "0 4px 80px" }}>
      <h1 style={{ fontSize: 26, fontWeight: 700, margin: "6px 0 4px" }}>Пряме підключення <span style={{ fontSize: 12, fontWeight: 700, padding: "2px 8px", borderRadius: 6, background: "rgba(16,185,129,0.14)", color: "#10b981", verticalAlign: "middle" }}>push · як MetaGo</span></h1>
      <div style={{ fontSize: 13, color: t.textMuted, marginBottom: 18, lineHeight: 1.6 }}>
        Альтернатива Spalah SDK. Meta й SEO-текст фізично вшиваються у статичний HTML сайту через плагін — Google бачить одразу, AI-краулери (ChatGPT/Perplexity) бачать нативно.
        <b> Працює паралельно з SDK</b> — це додатковий метод, не заміна. Тільки для self-hosted PHP (WordPress/OpenCart/кастом); для SaaS-конструкторів — лише SDK.
      </div>

      {/* Статус */}
      <div style={{ ...card, padding: 16, marginBottom: 18, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <span style={{ fontSize: 20 }}>🔌</span>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ fontSize: 14, fontWeight: 700 }}>Стан підключення</div>
          <div style={{ fontSize: 12, color: t.textMuted }}>
            {loading ? "Перевірка…"
              : status?.configured
                ? <>Ключ заданий · з'єднання: {status.connection ? <b style={{ color: "#10b981" }}>ok</b> : <b style={{ color: "#ef4444" }}>нема відповіді</b>}{typeof status.pages === "number" ? ` · сторінок у кеші: ${status.pages}` : ""}</>
                : "Ще не налаштовано — задайте ключ у налаштуваннях проєкту й поставте плагін за кроками нижче."}
          </div>
        </div>
        <span style={{ fontSize: 11, fontWeight: 700, padding: "4px 10px", borderRadius: 8, background: status?.configured ? "rgba(16,185,129,0.12)" : "rgba(245,158,11,0.12)", color: status?.configured ? "#10b981" : "#f59e0b" }}>
          {status?.configured ? "НАЛАШТОВАНО" : "НЕ НАЛАШТОВАНО"}
        </span>
      </div>

      <a href="/spalah-push.zip" download style={{ ...btnP, display: "inline-flex", alignItems: "center", gap: 8, textDecoration: "none", marginBottom: 14 }}>⬇️ Завантажити spalah-push.zip</a>
      <Step n="1" title="Поставити плагін у корінь сайту">
        Завантажте папку плагіна <code>spalah-push/</code> (база — перевірений плагін MetaGo, <code>github.com/SvitloAgency/metago</code>) у корінь сайту <code style={{ color: "#6366f1" }}>{domain}</code>, щоб був доступний шлях <code>{pluginPath}</code>. Переконайтесь, що тека <code>data/</code> доступна на запис (кеш meta).
      </Step>

      <Step n="2" title="Прописати ключ проєкту">
        <div style={{ display: "flex", gap: 8, margin: "2px 0 12px", flexWrap: "wrap" }}>
          <input value={keyVal} onChange={e => setKeyVal(e.target.value)} placeholder="ключ проєкту" style={{ ...inp, flex: 1, minWidth: 200 }} />
          <button onClick={() => saveKey(true)} disabled={keyBusy} style={{ ...btnG, fontSize: 12 }}>Згенерувати</button>
          <button onClick={() => saveKey(false)} disabled={keyBusy || !keyVal.trim()} style={{ ...btnP, fontSize: 12 }}>Зберегти</button>
        </div>
        У <code>config.php</code> плагіна вкажіть ключ авторизації цього проєкту (поле <code>legacy_metago_key</code> у налаштуваннях проєкту). Spalah пушить із заголовком <code>authorization: Client B &lt;KEY&gt;</code> — ключі мають збігатися.
        <Code>{`<?php\nreturn [\n  'key'  => 'ВАШ_КЛЮЧ_ПРОЄКТУ',\n  'path' => '${pluginPath}',\n];`}</Code>
      </Step>

      <Step n="3" title="Під'єднати підміну до виводу HTML">
        Плагін експортує <code>spalah_client_html_replace($html)</code>. Під'єднайте її до вихідного HTML (output buffering). Виберіть рушій:
        <div style={{ display: "inline-flex", gap: 4, margin: "10px 0", background: dark ? "#14141f" : "#eef1f7", borderRadius: 10, padding: 3 }}>
          {[["custom", "Кастом / PHP"], ["wp", "WordPress"], ["opencart", "OpenCart"]].map(([k, lbl]) => (
            <button key={k} onClick={() => setCms(k)} style={{ border: "none", borderRadius: 8, padding: "6px 12px", fontSize: 12, fontWeight: 600, cursor: "pointer", background: cms === k ? "#6366f1" : "transparent", color: cms === k ? "#fff" : t.text }}>{lbl}</button>
          ))}
        </div>
        <Code>{hookSnippets[cms]}</Code>
        <div style={{ fontSize: 12, color: t.textMuted, marginTop: 8 }}>Гарди (вшиті в плагін): підміна лише на <b>GET</b>, не на <code>/admin</code>, не на AJAX-запитах.</div>
      </Step>

      <Step n="4" title="Розмітка SEO-тексту (як у MetaGo)">
        <b>Meta й H1</b> підміняються автоматично по тегах — розмітка не потрібна.<br />
        <b>SEO-блок тексту</b> не має універсального місця, тому його позначають <b>маркером у ШАБЛОНІ</b> — один раз на тип сторінки (категорія / товар / стаття), не на кожну сторінку. Плагін заповнює маркер текстом для поточного URL.
        <div style={{ fontSize: 12, color: t.textMuted, margin: "10px 0 2px" }}>Варіант A — елемент-маркер (рекомендовано, той самий, що й у SDK):</div>
        <Code>{`<div data-spalah-seo></div>`}</Code>
        <div style={{ fontSize: 12, color: t.textMuted, margin: "10px 0 2px" }}>Варіант B — парні коментарі (якщо не можна вставити &lt;div&gt;):</div>
        <Code>{`<!--SPALAH:SEO-->\n<!--/SPALAH:SEO-->`}</Code>
        <div style={{ fontSize: 12.5, color: t.text, marginTop: 10, lineHeight: 1.6 }}>
          <b>Куди вставляти (на тип сторінки):</b><br />
          • Категорія → низ лістингу (<code>category</code>-шаблон)<br />
          • Товар → вкладка/низ опису (<code>product</code>-шаблон)<br />
          • Стаття/блог → тіло статті (<code>article/single</code>)<br />
          • Головна / кошик / службові → <b>не вставляти</b><br />
          Якщо вставити маркер неможливо — фолбек на CSS-селектор (напр. <code>.category-description</code>) або позицію before/after <code>&lt;footer&gt;</code>.
        </div>
      </Step>

      <Step n="5" title="Опублікувати й перевірити">
        У Spalah натисніть «Опублікувати на сайт» — meta+тексти пушаться в плагін. Перевірте сирий HTML (без JS):
        <Code>{`curl -s "https://${domain}/типова-сторінка/" | grep -iE "<title>|name=.description|<h1|data-spalah-seo"`}</Code>
        <div style={{ fontSize: 12.5, color: t.text, marginTop: 8 }}>У відповіді мають бути <b>підмінені</b> title/description/h1 і заповнений SEO-блок прямо в HTML — це означає, що Google і AI бачать їх нативно.</div>
      </Step>

      <div style={{ ...card, padding: 14, marginTop: 6, fontSize: 12, color: t.textMuted, lineHeight: 1.6 }}>
        <b style={{ color: t.text }}>Коротко про відмінність методів.</b> SDK (pull) — один <code>&lt;script&gt;</code>, просто, універсально, але AI-краулери не бачать. Пряме підключення (push) — плагін + розмітка, складніше поставити, зате meta/текст у статичному HTML → максимум для індексації Google і AI. Увімкніть той, що потрібен проєкту; можна обидва (гібрид).
      </div>
    </div>
  );
}
